module.exports = __webpack_public_path__ + "img/11.cfde43c1.jpg";